import {Link} from 'react-router-dom';
import './DocumentNameCell.scss';
import {
  extractReportId,
  NotificationTypes,
  getUrlFromString,
} from '../backgroundTasksUtils';
import {t} from 'i18next';

const DocumentNameCell = (data: any) => {
  const {
    documentUrl,
    documentName,
    notificationTypeCode: notificationType,
    message: reportUrl,
    reportStatus,
    id,
  } = data.params;

  if (!documentUrl) {
    return (
      <div data-testid={`document-name-cell-docName-${id}`}>{documentName}</div>
    );
  }

  switch (notificationType) {
    case NotificationTypes.CATEGORIZATION: {
      const match = documentUrl.match(/ProviewID=(\d+)/);
      const proviewID = match ? match[1] : '';
      if (proviewID) {
        return (
          <Link
            className="document-name-redirection-cell"
            to={`/Proview/Proview?proviewId=${proviewID}`}
          >
            {proviewID}
          </Link>
        );
      }
      return (
        <div data-testid={`document-name-cell-categrorization-${id}`}>
          {documentName}
        </div>
      );
    }
    case NotificationTypes.BACKGROUNDREPORT: {
      const match = reportUrl.match(/ReportID=(\d+)/);
      const reportID = match ? match[1] : '';
      if (reportID) {
        if (reportStatus === 'COMPLETED') {
          return (
            <Link
              className="document-name-redirection-cell"
              to={getUrlFromString(reportUrl, reportID, true)}
              state={{
                reportId: extractReportId(reportUrl),
                isBackgroundReport: true,
              }}
              data-testid={`redirection-${id}`}
            >
              {documentName}
            </Link>
          );
        }
      }
    }
    default:
      return (
        <div
          data-testid={`document-name-cell-default-${documentName.replaceAll(' ', '-')}-${id}`}
        >
          {documentName === t('backgroundTasks.customDataExportReport')
            ? t('backgroundTasks.dataExportReport')
            : documentName}
        </div>
      );
  }
};

export default DocumentNameCell;
